import React from 'react'

import { Button } from 'antd'
import { faSave, faTrash } from '@fortawesome/pro-solid-svg-icons'

import IconButton from '../Buttons/IconButton'
import PopoverIconButton from '../Buttons/PopoverIconButton'
import { isObject } from '../../../utils'

const FormFooter = ({ cancel = {}, remove = {}, submit = {}, onSubmit, onDelete, onCancel }) => {
  return (
    <div className='flex-row w-100 jc-between pd-12'>
      {isObject(remove) && !isObject(remove.popover) && (
        <IconButton
          disabled={remove.disabled}
          type='danger'
          text={remove.text}
          icon={faTrash}
          onClick={onDelete}
        />
      )}
      {isObject(remove) && isObject(remove.popover) && (
        <PopoverIconButton
          content={remove.popover.content}
          disabled={remove.disabled}
          icon={faTrash}
          text={remove.text}
          title={remove.popover.title}
          tooltipTitle={remove.tooltip ?? ''}
          type='danger'
          onConfirm={onDelete}
        />
      )}

      <div className='flex-fill' />

      {isObject(cancel) && (
        <Button onClick={onCancel} disabled={cancel.disabled} className='ml-8'>
          {cancel.text}
        </Button>
      )}
      {isObject(submit) && !isObject(submit.popover) && (
        <IconButton
          className='ml-8'
          icon={faSave}
          disabled={submit.disabled}
          type='primary'
          text={submit.text}
          onClick={onSubmit}
        />
      )}
      {isObject(submit) && isObject(submit.popover) && (
        <PopoverIconButton
          className='ml-8'
          content={submit.popover.content}
          disabled={submit.disabled}
          icon={faSave}
          text={submit.text}
          title={submit.popover.title}
          tooltipTitle={submit.tooltip ?? ''}
          type='primary'
          onConfirm={onSubmit}
        />
      )}
    </div>
  )
}

export default FormFooter
